/**
 * Hold transient messages until the captain can actually read them (16.98).
 *
 * Don's report: undocking plays the banner alert sound, and by the time the
 * screen is visible the message is gone. The timings say exactly why -- the
 * undock overlay runs 1200ms, the Expedition View's own arrival beat then covers
 * the screen with opaque black for 2600ms plus a 650ms fade, and the banner
 * hides itself after 2400ms. So the banner fired, chimed, and expired entirely
 * underneath two stacked overlays.
 *
 * The fix is not a longer banner -- that only makes the race less likely. A
 * message must not be *spent* while something is covering the screen.
 *
 * Counted rather than boolean, deliberately: those two transitions overlap, and
 * a boolean would have the undock overlay's cleanup unlock the gate while the
 * arrival beat was still black. Every `begin` needs its `end`, and the count is
 * floored at zero so a stray extra `end` cannot open the gate early either.
 *
 * Don's instruction was explicitly forward-looking -- "any future transition to
 * only display after we have loaded in to the screen" -- so this is the one hook
 * any new transition should call, rather than each one re-solving it.
 */

let depth = 0;

export function beginScreenTransition(): void {
  depth += 1;
}

export function endScreenTransition(): void {
  depth = Math.max(0, depth - 1);
}

export function isScreenTransitioning(): boolean {
  return depth > 0;
}

/** Test-only: no transition should ever survive a screen teardown. */
export function resetScreenTransitions(): void {
  depth = 0;
}
